import styled from '@emotion/styled';

const InputContainer = styled.div<{ compact?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1px;
  width: 100%;
  min-height: ${({ compact, theme }) =>
    compact
      ? 'auto'
      : `calc(${theme.fontSize.sm}px + ${theme.spacing[7]}px + ${theme.spacing[6]}px)`};
  &:focus-within {
    background-color: transparent;
  }
`;

const Label = styled.label`
  font-size: ${({ theme }) => theme.fontSize.lg}px;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-style: normal;
  line-height: 120%;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const InputWrapper = styled.div<{
  compact?: boolean;
  fullWidth?: boolean;
  hasLabel?: boolean;
}>`
  padding-top: ${({ compact, hasLabel, theme }) =>
    compact || !hasLabel ? '0' : `${theme.spacing[2]}px`};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  width: 100%;
`;

const StyledInputRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
`;

export const InputStyles = {
  InputContainer,
  Label,
  InputWrapper,
  StyledInputRow,
};
